import React from 'react';
import { motion } from 'framer-motion';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Home from './components/Home';
import TechSkills from './components/TechSkills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import LanguageSkills from './components/LanguageSkills';
import AppointmentForm from './components/AppointmentForm';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        
        <motion.main
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Home />
          <TechSkills />
          <Experience />
          <Projects />
          <LanguageSkills />
          <AppointmentForm />
        </motion.main>
        
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
